import axios from "axios";

const createAxiosInstance = (baseURL) => {
  const instance = axios.create({ baseURL });

  // // 캐시 저장소와 캐시 만료 시간 설정
  // const cache = new Map();
  // const CACHE_DURATION = 5 * 60 * 1000; // 5분 (밀리초 단위)

  // // 요청 인터셉터 추가
  // instance.interceptors.request.use(async (config) => {
  //   // GET 요청에 대해서만 캐싱 적용
  //   if (config.method === "get") {
  //     const cacheKey = `${config.url}${JSON.stringify(config.params || {})}`;
  //     const cachedData = cache.get(cacheKey);

  //     if (cachedData) {
  //       const { data, timestamp } = cachedData;
  //       if (Date.now() - timestamp < CACHE_DURATION) {
  //         // 유효한 캐시가 있으면 사용
  //         return Promise.reject({
  //           __fromCache: true,
  //           data: data,
  //         });
  //       }
  //       // 캐시가 만료되었으면 삭제
  //       cache.delete(cacheKey);
  //     }
  //   }
  //   return config;
  // });

  // 응답 인터셉터
  instance.interceptors.response.use(
    (response) => {
      // GET 요청에 대해서만 캐싱
      if (response.config.method === "get") {
        // const cacheKey = `${response.config.url}${JSON.stringify(
        //   response.config.params || {}
        // )}`;
        // cache.set(cacheKey, {
        //   data: response.data,
        //   timestamp: Date.now(),
        // });
      }
      return response.data;
    },
    (error) => {
      // 캐시된 데이터면 반환
      if (error.__fromCache) {
        return error.data;
      }
      // 에러를 상위로 전달
      return Promise.reject({
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        error: error,
      });
    }
  );

  return instance;
};

export default createAxiosInstance;
